import React from 'react'
import { useState, useEffect } from 'react'
import { SuspenseRootFallback } from '../Suspense'
import { useRelogin } from '../../Hooks/use-relogin'
import { useTypedSelector } from '../../State/RootReducer'
import { stringifyError, useNewRelic } from '../../Libs/observability-tool'

interface Props {
  children?: React.ReactNode
}

const Relogin: React.FC<Props> = ({ children }) => {
  const [loading, setLoading] = useState(true)
  const { pageActions } = useNewRelic()
  const isLogoutActive = useTypedSelector(state => state.app.isLogoutActive)
  const relogin = useRelogin()

  useEffect(() => {
    const _fetch = async (): Promise<void> => {
      try {
        await relogin()
      } catch (err) {
        pageActions.logEvent({ logValue: `Relogin-Error on relogin: ${stringifyError(err as Error)}` })
      } finally {
        setLoading(false)
      }
    }

    if (!isLogoutActive) {
      _fetch()
    } else {
      setLoading(false)
    }
  }, [isLogoutActive]) //eslint-disable-line

  if (loading) return <SuspenseRootFallback />
  return <>{children}</>
}

export default Relogin
